// import {
//   ConnectionLifecycle,
//   GameLifecycle,
//   IGameData,
//   IRoundState,
//   RoundLifecycle,
// } from "./types";

import { isArray } from "lodash";
import {
  reduceList,
  reduceListObj,
} from "./components/helper/functions/functions";

let lockedItem = "";
try {
  lockedItem = localStorage.getItem("lockedItem");
} catch (e) {
  console.log("localstorage error", e);
}

export const initialWsState = {
  connectionStatus: "PRE_CREATED",
  // gameStatus: "PRE_CREATED",
  isAdmin: false,
  // gameCode: undefined,
  // playerId: undefined,
  // players: new Map(),
  // playerCount: 1,
  lockedItems: {},
  lockedItem,
  updateTaskStack: {},
  currentConnectedUsers: [],
  lastConnectionRefresh: new Date(),
  //   roundState: {
  //     status: RoundLifecycle.USE,
  //     round: 0,
  //     pickedCardId: "",
  //     playerWon: "",
  //     question: "",
  //     judge: "",
  //     selectedCardId: "",
  //     isJudge: false,
  //     use: [],
  //     playersUsed: new Map(),
  //     pick: [],
  //   },
  //   scoreboard: [],
};

export function websocketReducer(state, { type, payload }) {
  switch (type) {
    case "GET_ALL_LOCKED_ITEMS": {
      // console.log("websocketReducer GET_ALL_LOCKED_ITEMS");
      // let fInd = lockedItems.findIndex(x=>x. payload.projectID
      // console.log("lock problem reducer getalllockeditems", payload.data);
      let lockedItems = state.lockedItems;
      if (lockedItems[payload.projectID]) {
        lockedItems[payload.projectID] = payload.data;
      } else {
        lockedItems = { ...lockedItems, [payload.projectID]: payload.data };
      }
      return {
        ...state,
        lockedItems,
      };
    }
    case "CONNECTED": {
      // console.log("websocketReducer CONNECTED");
      return {
        ...state,
        connectionStatus: "CONNECTED",
        lastConnectionRefresh: new Date(),
      };
    }
    case "USER_ENTERS": {
      console.log("websocketReducer USER_ENTERS", payload);
      let currentConnectedUsers = state.currentConnectedUsers;
      let data = payload;
      console.log("currentConnectedUsers befre", currentConnectedUsers);
      currentConnectedUsers.push(data);

      currentConnectedUsers = currentConnectedUsers.filter(
        (x) =>
          new Date(x.date).getTime() + 2 * 60 * 1000 + 30 * 1000 >
          new Date().getTime()
      );

      currentConnectedUsers = reduceListObj(currentConnectedUsers, "email");

      console.log("currentConnectedUsers", currentConnectedUsers);

      // console.log("currentConnectedUsers", currentConnectedUsers);
      return { ...state, currentConnectedUsers };
    }
    case "UPDATE_USER_ENTERS": {
      return { ...state, currentConnectedUsers: payload };
    }

    case "UPDATE_TASK": {
      console.log("updateTask data", payload);
      let updateTaskStack = state.updateTaskStack;
      if (!updateTaskStack[payload.projectID]) {
        updateTaskStack[payload.projectID] = {};
      }

      if (!updateTaskStack[payload.projectID][payload.itemID]) {
        updateTaskStack[payload.projectID][payload.itemID] = {};
      }

      let lastPostId = new Date().getTime();
      updateTaskStack[payload.projectID][payload.itemID][lastPostId] = {
        email: payload.email,
        data: payload.taskData,
      };
      // console.log(
      //   "reducer update task",
      //   updateTaskStack[payload.projectID][payload.itemID][lastPostId]
      // );
      // console.log("websocket#Reducer UPDATE_TASK", updateTaskStack);

      return { ...state, updateTaskStack };
    }
    case "REMOVE_UPDATE_TASK": {
      // console.log("remove update task", payload);
      let updateTaskStack1 = state.updateTaskStack;
      if (!updateTaskStack1[payload.projectID]) {
        updateTaskStack1[payload.projectID] = {};
        if (!updateTaskStack1[payload.projectID][payload.itemID]) {
          updateTaskStack1[payload.projectID][payload.itemID] = {};
          if (
            updateTaskStack1[payload.projectID][payload.itemID][
              payload.lastPostId
            ]
          ) {
            delete updateTaskStack1[payload.projectID][payload.itemID][
              payload.lastPostId
            ];
          }
        }
      }

      return { ...state, updateTaskStack: updateTaskStack1 };
    }
    case "ITEM_LOCK": {
      // console.log("websocketReducer ITEM_LOCK");
      // localStorage.setItem("lockedItem", payload.itemID);
      // console.log("lock problem reducer itemlock", payload, state.lockedItems);
      let lockedItems = state.lockedItems;
      if (payload.itemID !== "")
        if (
          lockedItems[payload.projectID] &&
          isArray(lockedItems[payload.projectID])
        ) {
          let fInd = lockedItems[payload.projectID].findIndex(
            (x) => x.itemID === payload.itemID
          );
          if (fInd > -1) {
            lockedItems[payload.projectID][fInd].email = payload.email;
          } else {
            lockedItems[payload.projectID].push({
              email: payload.email,
              itemID: payload.itemID,
            });
          }
        } else {
          lockedItems = {
            ...lockedItems,
            [payload.projectID]: [
              {
                email: payload.email,
                itemID: payload.itemID,
              },
            ],
          };
        }

      return { ...state, lockedItems };
    }
    case "CONNECTION_REFRESHED":
      // console.log("WEBSOCKET connection validated", new Date());
      return { ...state, lastConnectionRefresh: new Date() };
    case "ITEM_UNLOCK": {
      // console.log("websocketReducer ITEM_UNLOCK");
      // localStorage.setItem("lockedItem", payload.itemID);kj
      // console.log("item unlock reducer", payload);
      let lockedItems = state.lockedItems;
      if (payload.itemID !== "")
        if (
          lockedItems[payload.projectID] &&
          isArray(lockedItems[payload.projectID])
        ) {
          if (payload.newUser === "") {
            lockedItems[payload.projectID] = lockedItems[
              payload.projectID
            ].filter((x) => x.itemID !== payload.itemID);
          } else {
            let fN = lockedItems[payload.projectID].findIndex(
              (x) => x.itemID === payload.itemID
            );
            if (fN > -1) {
              lockedItems[payload.projectID][fN].email = payload.newUser;
            } else {
              lockedItems[payload.projectID].push({
                email: payload.newUser,
                itemID: payload.itemID,
              });
            }
          }
        }

      return { ...state, lockedItems };
    }
    case "RECONNECTION_AFTER_RENDER": {
      // console.log("websocketReducer RECONNECTION_AFTER_RENDER");
      const newRoundState = {
        ...state.roundState,
        status: "WAITING_FOR_DATA",
      };
      return {
        ...state,
        // gameCode: payload.game,
        // playerId: payload.id,
        connectionStatus: "REFRESHING",
        // gameStatus: "CREATED",
        roundState: newRoundState,
      };
    }
    case "REFRESH_FAILED": {
      // console.log("websocketReducer REFRESH_FAILED");
      return { ...state, connectionStatus: "PRE_CREATED" };
    }
    case "REJOIN": {
      // console.log("websocketReducer REJOIN");
      return {
        ...state,
        connectionStatus: "RESUMED",
        // playerId: payload.newId,
        // gameCode: payload.game,
        // players: new Map(payload.players),
      };
    }
    // case "JOINED_MID_GAME": {
    //   console.log("websocketReducer REJOIN");
    //   const newRoundState = {
    //     ...state.roundState,
    //     status: "WAITING_FOR_DATA",
    //   };
    //   return {
    //     ...state,
    //     gameStatus: "RESUMED",
    //     roundState: newRoundState,
    //   };
    // }
    // case "PLAYER_JOINED": {
    //   console.log("websocketReducer PLAYER_JOINED");
    //   return {
    //     ...state,
    //     playerCount: payload.count,
    //     players: state.players.set(payload.joinedId, payload.joined),
    //     isAdmin: payload.isAdmin,
    //   };
    // }
    // case "CONNECTION_RESUME": {
    //   console.log("websocketReducer CONNECTION_RESUME");
    //   const oldPlayer = state.players;
    //   state.players.delete(payload.from);
    //   return {
    //     ...state,
    //     playerCount: payload.count,
    //     players: state.players.set(payload.to, oldPlayer),
    //     isAdmin: payload.isAdmin,
    //   };
    // }
    // case "CONNECTION_PAUSE": {
    //   console.log("websocketReducer CONNECTION_PAUSE");
    //   return {
    //     ...state,
    //     playerCount: payload.count,
    //     isAdmin: payload.isAdmin,
    //   };
    // }
    // case "PLAYER_LEFT": {
    //   console.log("websocketReducer PLAYER_LEFT");
    //   state.players.delete(payload.leftId);
    //   return {
    //     ...state,
    //     playerCount: payload.count,
    //     players: state.players,
    //     isAdmin: payload.isAdmin,
    //   };
    // }
    // case "GAME_STARTED": {
    //   console.log("websocketReducer GAME_STARTED");
    //   return { ...state, gameStatus: "RESUMED" };
    // }
    // case "ROUND_STARTED": {
    //   console.log("websocketReducer ROUND_STARTED");
    //   const { roundState: prev } = state;
    //   const { q, j, isJudge, use } = payload;
    //   const newRoundState = {
    //     status: isJudge ? "PENDING_PLAYER_USAGES" : "USE",
    //     round: prev.round + 1,
    //     pickedCardId: "",
    //     selectedCardId: "",
    //     playerWon: "",
    //     question: q,
    //     judge: j,
    //     isJudge,
    //     use,
    //     pick: [],
    //     playersUsed: new Map(),
    //   };
    //   return {
    //     ...state,
    //     roundState: newRoundState,
    //   };
    // }
    // case "CARD_SELECTED": {
    //   console.log("websocketReducer ROUND_STARTED");
    //   const newRoundState = {
    //     ...state.roundState,
    //     selectedCardId: payload.selected,
    //   };
    //   return { ...state, roundState: newRoundState };
    // }
    // case "CARD_USED": {
    //   console.log("websocketReducer CARD_USED");
    //   const newRoundState = {
    //     ...state.roundState,
    //     status: "PENDING_PLAYER_USAGES",
    //   };
    //   return { ...state, roundState: newRoundState };
    // }
    // case "PLAYER_USAGE": {
    //   console.log("websocketReducer PLAYER_USAGE");
    //   const { roundState: prevState } = state;
    //   const newRoundState = {
    //     ...prevState,
    //     playersUsed: prevState.playersUsed.set(
    //       payload.playerId,
    //       payload.playerName
    //     ),
    //   };
    //   return { ...state, roundState: newRoundState };
    // }
    // case "PICK": {
    //   console.log("websocketReducer PICK");
    //   const newRoundState = {
    //     ...state.roundState,
    //     pick: payload.pick,
    //     status: state.roundState.isJudge ? "PICK" : "PENDING_JUDGE_PICK",
    //   };
    //   return { ...state, roundState: newRoundState };
    // }
    // case "ROUND_ENDED":
    // case "ROUND_ENDED_404": {
    //   console.log("websocketReducer ROUND_ENDED");
    //   const newRoundState = {
    //     ...state.roundState,
    //     playerWon: payload.playerWon,
    //     pickedCardId: payload.winningCard,
    //     status: "PENDING_ADMIN_ACTION",
    //   };
    //   return { ...state, roundState: newRoundState };
    // }
    // case "PAUSE": {
    //   console.log("websocketReducer PAUSE");
    //   return {
    //     ...state,
    //     gameStatus: "PAUSED",
    //   };
    // }
    // case "GAME_PAUSED": {
    //   console.log("websocketReducer GAME_PAUSED");
    //   return { ...state, gameStatus: "PAUSED" };
    // }
    // case "GAME_RESUMED": {
    //   console.log("websocketReducer GAME_RESUMED");
    //   return { ...state, gameStatus: "RESUMED" };
    // }
    // case "GAME_ENDED": {
    //   console.log("websocketReducer GAME_ENDED");
    //   return {
    //     ...state,
    //     gameStatus: "STOPPED",
    //     scoreboard: payload.scores,
    //   };
    // }
    // case "GAME_INTERRUPTED": {
    //   console.log("websocketReducer GAME_INTERRUPTED");
    //   return {
    //     ...state,
    //     gameStatus: "DESTROYED",
    //   };
    // }
    case "SESSION_PAUSED": {
      // console.log("websocketReducer SESSION_PAUSED");
      return {
        ...state,
        connectionStatus: "PAUSED",
      };
    }
    case "DISCONNECTED": {
      // console.log("websocketReducer DISCONNECTED");
      return {
        ...state,
        connectionStatus: "DESTROYED",
        lastConnectionRefresh: null,
      };
    }
    case "GOING_AWAY": {
      // console.log("websocketReducer GOING_AWAY");
      return { ...state, connectionStatus: "GOING_AWAY" };
    }
    default: {
      return state;
    }
  }
}
